export default ({
	loaderColor,
	loading = true,
	text = "Loading"
}) => {
	if(!loading){
		return null
	}

	return (
		<div style={{
			width: "100%",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			height: "30px",
			marginBottom: "20px"
		}}>
			<span className="loader" style={loaderColor && {"--dark-color": loaderColor}} />
			<span style={{marginLeft: "20px"}}>{text}</span>
		</div>
	)
}
